import React from 'react';
import { Parallax } from 'react-parallax';
import Navigation from './Navigation';
import Footer from '../components/Footer';

const Page = props => (
  <div>
    <Navigation navigation={props.navigation} />
    <section id="about" style={{ paddingTop: 0 }}>
      <Parallax blur={0} bgImage={props.data.img} bgImageAlt={props.data.title} strength={120}>
        <div style={{ height: '300px' }} />
      </Parallax>
      <div className="container pb-2">
        <div className="row">
          <h1
            className="display-1 hidden-down pt-2"
            style={props.data.title.length > 30 ? { fontSize: '4.5em' } : { fontSize: '5em' }}
          >
            {props.data.title}
          </h1>
          <div className="col-xl-4 col-lg-4 col-md-5 pt-2 pb-2" />
        </div>
        <div className="row pt-2">
          <div className="col-md-12 lead">
            <div dangerouslySetInnerHTML={{ __html: props.data.body }} />
          </div>
        </div>
      </div>
    </section>
    <Footer footer={props.footer} />
  </div>
);
export default Page;



// WEBPACK FOOTER //
// ./src/components/Page.js